import React from "react";

const VariantOption = ({ type, label, color, handleClick, value, currentSelect }) => {
  return (
    <li
      className={`custom-select--item ${currentSelect?.value == value && "custom-select--item--active"}`}
      onClick={() => {
        handleClick(value, type, label);
      }}
    >
      {type == "color" && (
        <div className="custom-select__colorIndicator" style={{ background: color ? color : value }}></div>
      )}
      <span>{label}</span>
    </li>
  );
};

export default VariantOption;
